import { render, staticRenderFns } from "./EmailMessageStatement.vue?vue&type=template&id=04645b10&scoped=true"
import script from "./EmailMessageStatement.vue?vue&type=script&lang=js"
export * from "./EmailMessageStatement.vue?vue&type=script&lang=js"
import style0 from "./EmailMessageStatement.vue?vue&type=style&index=0&id=04645b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04645b10",
  null
  
)

export default component.exports